const ver = require('./assets/version.json');
export const appProjectInfo = {...ver,
    "analyticsID": "UA-93749543-1"
};
